export default __webpack_public_path__ + "static/media/milestone 1300.e77fec13.svg";